/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListToolsetsForOrgSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ListToolsetsForOrgRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ListToolsetsForOrgSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListToolsetsForOrgSecurity$outboundSchema: z.ZodMiniType<
  ListToolsetsForOrgSecurity$Outbound,
  ListToolsetsForOrgSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function listToolsetsForOrgSecurityToJSON(
  listToolsetsForOrgSecurity: ListToolsetsForOrgSecurity,
): string {
  return JSON.stringify(
    ListToolsetsForOrgSecurity$outboundSchema.parse(listToolsetsForOrgSecurity),
  );
}

/** @internal */
export type ListToolsetsForOrgRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListToolsetsForOrgRequest$outboundSchema: z.ZodMiniType<
  ListToolsetsForOrgRequest$Outbound,
  ListToolsetsForOrgRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function listToolsetsForOrgRequestToJSON(
  listToolsetsForOrgRequest: ListToolsetsForOrgRequest,
): string {
  return JSON.stringify(
    ListToolsetsForOrgRequest$outboundSchema.parse(listToolsetsForOrgRequest),
  );
}
